import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5e78c5ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-container" }

import { ref, computed } from "vue";
import { useAuthStore } from "@/store/auth/login";

import InnerPageLayout from "@/widgets/layouts/InnerPageLayout.vue";
import TopCampaignPanel from "@/entities/campaigns/panels/TopCampaignPanel.vue";
import CampaignCreateForm from "@/entities/campaigns/forms/CampaignCreateForm.vue";
import HandlerAccessDenied from "@/shared/base/HandlerAccessDenied.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CampaignPage',
  setup(__props) {

const isLoading = ref(false);
const createFormRef = ref<InstanceType<typeof CampaignCreateForm> | null>(null);
const authStore = useAuthStore();

const isDenied = computed(() => {
  return authStore.isDeniedForPermissions([
    "campaign:read",
    "campaign:edit",
    "system:read",
    "system:edit",
  ]);
});

const isDeniedSave = computed(() => {
  return authStore.isDeniedForPermissions(["campaign:edit", "system:edit"]);
});

const createCampaign = () => {
  if (createFormRef.value) createFormRef.value.createCampaign();
};

const setLoading = (value: boolean) => {
  isLoading.value = value;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InnerPageLayout, null, {
    default: _withCtx(() => [
      _createVNode(HandlerAccessDenied, { "is-denied": isDenied.value }, {
        default: _withCtx(() => [
          _createVNode(TopCampaignPanel, {
            "is-button-disabled": isDeniedSave.value,
            isLoading: isLoading.value,
            onCreateCampaign: createCampaign
          }, null, 8, ["is-button-disabled", "isLoading"]),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(CampaignCreateForm, {
              isLoading: isLoading.value,
              onSetLoading: setLoading,
              ref_key: "createFormRef",
              ref: createFormRef
            }, null, 8, ["isLoading"])
          ])
        ]),
        _: 1
      }, 8, ["is-denied"])
    ]),
    _: 1
  }))
}
}

})